import { Suspense } from "react";
import { Outlet } from "react-router-dom";
import { Box, Container, useMediaQuery, useTheme } from "@mui/material";
import RecaptchaTerms from "@/components/recaptchaTerms";
import { TaskerMessageProvider } from "@/components/tasker/TaskerMessageContext";
import { TaskerNavigation } from "./TaskerNavigation";
import { ProgramProvider } from "@/context/ProgramContext";
import { ScrollRestoration } from "@/components/ScrollRestoration";

const TaskerLayoutInternal = ({ children }: { children: React.ReactNode }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Box sx={{ display: "flex", flexDirection: "column" }}>
      <TaskerNavigation />
      <Box
        id="main-content"
        component="main"
        sx={{
          backgroundColor: (theme) =>
            theme.palette.mode === "light"
              ? theme.palette.grey[100]
              : theme.palette.grey[900],
          minHeight: "100vh",
          pb: { xs: 7, md: 0 },
        }}
      >
        <Container
          maxWidth="xl"
          sx={{ mt: isMobile ? 2 : 13, mb: isMobile ? 6 : 2 }}
        >
          {children}
        </Container>
        <RecaptchaTerms />
      </Box>
    </Box>
  );
};

export const TaskerLayout = () => (
  <ProgramProvider>
    <TaskerMessageProvider>
      <TaskerLayoutInternal>
        <ScrollRestoration />
        <Suspense fallback={<div>Loading...</div>}>
          <Outlet />
        </Suspense>
      </TaskerLayoutInternal>
    </TaskerMessageProvider>
  </ProgramProvider>
);
